import { render, staticRenderFns } from "./tie.vue?vue&type=template&id=7604c05a&scoped=true"
import script from "./tie.vue?vue&type=script&lang=js"
export * from "./tie.vue?vue&type=script&lang=js"
import style0 from "./tie.vue?vue&type=style&index=0&id=7604c05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604c05a",
  null
  
)

export default component.exports